module.exports = function() {
  return new Worker(__webpack_public_path__ + "68d853524d8d50728e49.worker.js");
};